// extracted by mini-css-extract-plugin
var _1 = "cDZ5sVvtuto0KyhIdTwT";
export { _1 as "visuallyHidden" }
